// extracted by mini-css-extract-plugin
export default {"spinner":"FullPageLoader_spinner__ySRSc","headline":"FullPageLoader_headline__LLNPy"};